<template>
  <div class="k-directory">
    <label v-if="label">{{ label }}</label>
    <div class="k-directory__content">
      <div v-if="breadcrumbs.length !== 0" class="k-directory__navigation">
        <div @click.prevent="goBack" class="k-directory__navigation-action row center middle">
          <FontAwesomeIcon :icon="['fal', 'angle-left']" />
          <span>{{ $t('back') }}</span>
        </div>
        <span>-</span>
        <template v-for="(item, index) in breadcrumbs">
          <FontAwesomeIcon
            class="k-directory__navigation-breadcrumb-seperator"
            v-if="index"
            :key="`seperator_${index}`"
            :icon="['fal', 'angle-right']"
          />
          <span class="k-directory__navigation-action" :key="index" @click="navigate(index)">{{
            item
          }}</span>
        </template>
      </div>

      <Render
        :path.sync="path"
        :readonly="readonly"
        :value="value"
        :upload-options="uploadOptions"
        @create="newFolder"
        @remove="deleteFolder"
        @input="$ev => $emit('input', $ev)"
      >
        <template #content-top="{ item }">
          <slot name="content-top" :item="item" />
        </template>
      </Render>
    </div>
  </div>
</template>

<script>
import Render from './Render'
import { NewFolderName, EscapeRegex } from './utils'

function convertPathToString(value) {
  return value.join('/')
}

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    label: String,
    readonly: {
      type: Boolean,
      default: false,
    },
    uploadOptions: Object,
  },
  data() {
    return {
      path: '',
    }
  },
  computed: {
    breadcrumbs() {
      return this.path ? this.path.split('/') : []
    },
  },
  methods: {
    newFolder() {
      let current = convertPathToString(this.breadcrumbs)
      let path = NewFolderName(current, this.value, { name: this.$t('newFolder') })

      this.value.push({ path })
      this.$bus.$emit('add:folder', path)
    },
    deleteFolder(item) {
      let deletePath = new RegExp(`^${EscapeRegex(item.path)}$|^${EscapeRegex(item.path)}/`)

      this.$emit(
        'input',
        this.value.filter(element => !deletePath.test(element.path)),
      )
    },
    goBack() {
      this.path = convertPathToString(this.breadcrumbs.slice(0, -1))
    },
    navigate(index) {
      this.path = convertPathToString(this.breadcrumbs.slice(0, index + 1))
    },
  },
  components: {
    Render,
  },
}
</script>

<style lang="scss">
.k-directory {
  & > label {
    font-weight: bold;

    & + .k-directory__content {
      margin-top: 0.5em;
      border: 1px solid var(--border-color);
      border-radius: var(--border-radius);
      padding: 1.1em;
    }
  }

  &__navigation {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    color: rgba(black, 0.7);

    border-bottom: 1px dashed var(--border-color);

    max-width: 100%;
    overflow-y: auto;

    padding-bottom: 1rem;
    margin-bottom: 1rem;

    &-action {
      display: flex;
      gap: 0.5rem;
      cursor: pointer;

      &:hover,
      &:last-child {
        color: var(--primary);
      }

      &--disabled {
        pointer-events: none;
        opacity: 0.4;
      }
    }
  }
}
</style>
